import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const DepositPOPUP = ({ banks = [], savedData = [], onAdd }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    amount: "",
    name: "",
    mode: "Cash",
    bank_name: "",
  });

  const reset = () =>
    setForm({ amount: "", name: "", mode: "Cash", bank_name: "" });

  const submit = async () => {
    if (!form.amount) return;
    const payload = {
      amount: form.amount,
      name: form.name,
      mode: form.mode,
      bank_show: form.mode !== "Cash",
      bank_name: form.mode !== "Cash" ? form.bank_name : "",
    };
    const token = localStorage.getItem("authToken");
    try {
      await axios.post(
        `${API_BASE_URL}/api/depositsave`,
        {
          token,
          name: payload.name,
          amount: payload.amount,
          mode: payload.mode,
          bank_name: payload.bank_name,
        },
        { headers: { "Content-Type": "application/json" } },
      );
      onAdd && onAdd(payload);
    } catch (e) {
      onAdd && onAdd(payload); // fallback local add
    } finally {
      reset();
      setOpen(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-warning"
        onClick={() => setOpen(true)}
      >
        Add Deposit
      </button>
      {open && (
        <div className="modal d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Deposit</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setOpen(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    value={form.amount}
                    onChange={(e) =>
                      setForm({ ...form, amount: e.target.value })
                    }
                  />
                </div>
                <div className="form-group">
                  <label>Name</label>
                  <select
                    className="form-control"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    required
                  >
                    <option value="">Select name</option>
                    {savedData.map((i, idx) => (
                      <option key={idx} value={i.name}>
                        {i.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Mode</label>
                  <select
                    className="form-control"
                    value={form.mode}
                    onChange={(e) => setForm({ ...form, mode: e.target.value })}
                  >
                    <option>Cash</option>
                    <option>Scan</option>
                    <option>Swipe</option>
                    <option>Bank</option>
                  </select>
                </div>
                {form.mode !== "Cash" && (
                  <div className="form-group">
                    <label>Bank</label>
                    <select
                      className="form-control"
                      value={form.bank_name}
                      onChange={(e) =>
                        setForm({ ...form, bank_name: e.target.value })
                      }
                      required
                    >
                      <option value="">Select bank</option>
                      {banks.map((i, idx) => (
                        <option key={idx} value={i.name}>
                          {i.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setOpen(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={submit}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DepositPOPUP;
